import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@tosize/ui";
import type { ComponentProps } from "react";

interface RoundButtonProps extends ComponentProps<"button"> {
	icon: IconProp;
}

export default function RoundButton(props: RoundButtonProps) {
	const { icon, className, ...remainingProps } = props;

	return (
		<button
			type="button"
			className={cn(
				className,
				"flex items-center justify-center rounded-full border border-shades-medium bg-white text-primary-dark shadow-sm transition hover:bg-shades-medium-light disabled:bg-shades",
				{
					"p-2": !props.children,
					"child:mr-2 px-2 py-1 last:child:mr-0": !!props.children,
				},
			)}
			{...remainingProps}
		>
			<FontAwesomeIcon className="h-4 w-4" icon={icon} />
			{props.children}
		</button>
	);
}
